export default __webpack_public_path__ + "static/media/logopress_villain.e23b4f02.png";